import React from 'react';
import styled from 'styled-components';
import Paper from '@mui/material/Paper';

const TimelinePanel = (props: React.PropsWithChildren) => {
    return (
        <FloatingEl>
            <Paper>{props.children}</Paper>
        </FloatingEl>
    );
};

const FloatingEl = styled.div`
    z-index: 1;
    pointer-events: all;
    background-color: transparent;
    padding: 0.5rem;
    grid-column: sidebar-end / page-end;
    grid-row: timeline-top / timeline-bottom;
    justify-self: center;
    min-width: 900px;
`;

export default TimelinePanel;
